<template>
  <div>
    <CheckoutAddressForm
      ref="billingForm"
      :form-fields="billingFields"
      :default-values="defaultValuesForBilling"
      form-name="billing"
      :user-logged-in="userLoggedIn"
    />
    <CheckoutAddressForm
      ref="shippingForm"
      :form-fields="shippingFields"
      :default-values="defaultValuesForShipping"
      form-name="shipping"
      :user-logged-in="userLoggedIn"
    />
    <div class="form-footer">
      <button
        class="btn btn--block"
        @click.prevent="validateForms()"
      >
        {{ $modeoL10n.continue }}
      </button>
      <p class="form-disclaimer">
        {{ $modeoL10n.asterisk_explanation }}
      </p>
    </div>
  </div>
</template>

<script>
    import CheckoutAddressForm from './checkout-address-form.vue';

    export default {
        components: {
            CheckoutAddressForm,
        },
        props: {
            billingFields: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            shippingFields: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            defaultValuesForBilling: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            defaultValuesForShipping: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            userLoggedIn: Boolean,
        },
        methods: {
            validateForms() {
                const billingFormKey = 0;
                const shippingFormKey = 1;
                let formPromises = [];
                formPromises.push(this.$refs.billingForm.validate());

                if (this.$refs.shippingForm.useShippingAddress) { // We only need to take care of valid shipping form, if that form is in use
                    formPromises.push(this.$refs.shippingForm.validate());
                }

                Promise.all(formPromises).then( (formsAreValid) => {
                    if (formsAreValid.every( (formIsValid) => formIsValid)) {
                        if (this.userLoggedIn) {
                            window.location.href = "#tarjouspyynto";
                        } else {
                            window.location.href = "#toimitustapa";
                        }
                    } else {
                        if (!formsAreValid[billingFormKey]) {
                            window.location.href = "#billing-form";
                        } else if (!formsAreValid[shippingFormKey]) {
                            window.location.href = "#shipping-form";
                        }
                    }
                });
            },
        },
    }
</script>
